import { METRIC, Metric } from "@/constants";

export const metricTitleMapping: Partial<Record<Metric, string>> = {
  [METRIC.INSIGHTS_TOP_CHANNELS]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_CHANNELS_TABLE,
  [METRIC.INSIGHTS_TOP_MENTIONS]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_MENTIONS_TABLE,
  [METRIC.INSIGHTS_MENTIONS_REACH]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_MENTIONS_REACH_TABLE,
  [METRIC.INSIGHTS_NUM_MENTIONS_OVER_TIME]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_NUM_MENTIONS_LINE_INSIGHTS,
  [METRIC.INSIGHTS_REACH_OVER_TIME]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_REACH_OVER_TIME_INSIGHTS,
  [METRIC.INSIGHTS_REACH_OVER_TIME_AUDIO]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_REACH_AUDIO_INSIGHTS,
  [METRIC.INSIGHTS_REACH_OVER_TIME_SOCIAL]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_REACH_SOCIAL_INSIGHTS,
  [METRIC.INSIGHTS_PR_VALUE_OVER_TIME]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_PR_VALUE_LINE_INSIGHTS,
  [METRIC.INSIGHTS_NUM_CHANNELS_OVER_TIME]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_NUM_CHANNELS_INSIGHTS,
  [METRIC.INSIGHTS_SENTIMENT_OVER_TIME_PER_MEDIA_CATEGORY]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_PER_MEDIUM_INSIGHTS,
  [METRIC.INSIGHTS_NUM_MENTIONS_PER_MEDIA_CATEGORY]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_MEDIA_TYPE_SHARE_INSIGHTS,
  [METRIC.INSIGHTS_SENTIMENT]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_SENTIMENT_SHARE_INSIGHTS,
  [METRIC.INSIGHTS_WORD_CLOUD]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_WORD_CLOUD,
  [METRIC.INSIGHTS_MENTION_TOPICS]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS,
  [METRIC.INSIGHTS_MENTION_TOPICS_OVER_TIME]:
    L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS_OVER_TIME,
  [METRIC.INSIGHTS_MENTIONS_PER_PEST_CATEGORY]: L.REPORTS_WIDGET_PEST_TITLE,
};
